import { FormControl } from "@angular/forms";

export const NameValidator = (control?: FormControl, length?: number) => {
	if (control.value) {
		const nameRegEx = /^[a-zA-Z'\- ]+$/i;
		const valid = nameRegEx.test(control.value);
		const validLength = !(control.value.length > length);
		let error = null;
		if (!valid) {
			error = returnError("Please enter a valid name");
		} else if (!validLength) {
			error = returnError(`Should not exceed ${length} characters.`);
		}
		return error;
	}
};

const returnError = (message: string) => ({
	nameInvalid: {
		valid: false,
		message,
	},
});
